// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_contetnt_in_shedule_page {
  flex: 1 1;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/pages/SchedulePage/SchedulePage.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,kBAAA;AACJ","sourcesContent":[".main_contetnt_in_shedule_page {\r\n    flex: 1;\r\n    position: relative;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
